import React from 'react';
import { Form } from 'formik';
import { Persist } from '../components/Persist';
import CountryRegionData from 'country-region-data';

import {
  Typography,
  Grid,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  FormGroup,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Link
} from '@material-ui/core';

import { KeyboardArrowDown } from '@material-ui/icons';

import {
  injectStripe,
  StripeProvider,
  Elements
} from 'react-stripe-elements';

import StripeElements from './StripeElements';
import ErrorMessage from '../components/ErrorMessage';

const InjectedStripeElements = injectStripe(StripeElements, {withRef: true});
const regions = CountryRegionData.find(country => country.countryShortCode === 'US').regions;

const OrderForm = ({
  values,
  handleChange,
  handleBlur,
  setFieldValue,
  errors,
  touched,
  isValid,
  isLoading,
  errorMessage,
  classes,
  stripe,
  terms,
  toggleTerms
  /* entire "formik bag" available */
}) => {
  const setStripeToken = value => setFieldValue('user.stripe_token', value);

  return (
    <Form className={`${classes.form} ${classes.orderForm}`}>
      <Grid container spacing={3}>
        <Grid className={classes.sectionTitle} item xs={12}>
          <Typography variant="subtitle1">Service Address</Typography>
        </Grid>

        { errorMessage ? <ErrorMessage errorMessage={errorMessage} /> : '' }

        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            name="address.address1"
            label="Address"
            fullWidth
            autoComplete="shipping street-address"
            value={values.address.address1}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {errors.address && errors.address.address1 && touched.address && touched.address.address1 ? (
            <FormHelperText error>{errors.address.address1}</FormHelperText>
          ) : null}
        </Grid>
        <Grid item xs={12}>
          <TextField
            className={classes.textField}
            name="address.city"
            label="City"
            fullWidth
            autoComplete="shipping address-level2"
            value={values.address.city}
            onChange={handleChange}
            onBlur={handleBlur}
            disabled
          />
          {errors.address && errors.address.city && touched.address && touched.address.city ? (
            <FormHelperText error>{errors.address.city}</FormHelperText>
          ) : null}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>State</InputLabel>
            <Select
              className={classes.select}
              value={values.address.state}
              onChange={handleChange}
              name="address.state"
              displayEmpty
              fullWidth
              disabled
              IconComponent={props =>
                <KeyboardArrowDown
                  {...props}
                />
              }
            >
              {regions.map(region =>
                <MenuItem key={region.name} value={region.shortCode}>
                  {region.name}
                </MenuItem>
              )}
            </Select>
            {errors.address && errors.address.state && touched.address && touched.address.state ? (
              <FormHelperText error>{errors.address.state}</FormHelperText>
            ) : null}
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            className={classes.textField}
            name="address.zipcode"
            label="Visit Zip Code / Postal Code"
            fullWidth
            autoComplete="shipping postal-code"
            value={values.address.zipcode}
            onChange={handleChange}
            onBlur={handleBlur}
            inputProps={{maxLength: 5}}
            disabled
          />
          {errors.address && errors.address.zipcode && touched.address && touched.address.zipcode ? (
            <FormHelperText error>{errors.address.zipcode}</FormHelperText>
          ) : null}
        </Grid>

        <Grid className={classes.section} item xs={12}>
          <Grid container spacing={3}>
            <Grid className={classes.sectionTitle} item xs={12}>
              <Typography variant="subtitle1">Payment</Typography>
            </Grid>

            <StripeProvider stripe={stripe}>
              <Elements>
                <InjectedStripeElements setStripeToken={setStripeToken} />
              </Elements>
            </StripeProvider>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <FormGroup row>
            <FormControlLabel
              className={classes.terms}
              control={
                <Checkbox
                  checked={terms}
                  onChange={toggleTerms}
                  color="primary"
                  name="terms"
                />
              }
              label={<span>I understand that I am purchasing a service subject to Handy&apos;s <Link rel="noopener noreferrer" target="_blank" href="https://www.handy.com/terms">Terms of Use and Cancellation Policy</Link> and my payment method will be charged before the service. I acknowledge that information pertaining to this booking may be shared with Google Nest who may share it in accordance with its terms and conditions.</span>}
            />
          </FormGroup>
        </Grid>

        <Grid item xs={12}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            className={classes.button}
            type="submit"
            fullWidth
            disabled={!isValid || !values.user.stripe_token || !terms || isLoading}
          >
            {isLoading 
              ? <CircularProgress size={35} />
              : 'Complete'
            }
          </Button>
          <Persist
            isSessionStorage={true}
            name="order-form"
            ignoreFields={['user.stripe_token']}
            prefilledFields={['address.zipcode', 'address.city', 'address.state']}
          />
        </Grid>
      </Grid>
    </Form>
  );
}

export default OrderForm;